import React, { FC, useCallback, useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { BreadCrumbs } from "../../../components/BreadCrumbs/breadCrumbrs"
import { Button } from "../../../components/Button/Button"
import { ModalDelete } from "../../../components/Modals/General/ModalDelete/ModalDelete"
import { ModularDataTable } from "../../../components/ModularDataTable"
import useModals from "../../../hooks/useModals"
import { i18n } from "../../../translate/i18n"
import {  AggregatorPublicity, typeBannerHotel } from "./agregador-publicity.type"
import { createActions } from "./factory/actionsFactory"
import { createColumns } from "./factory/generateColumns"
import { useAgregadorPublicity } from "./factory/useAgregadorPublicity"



const AggregadorBannerIndex: FC = () => {
  const navigate = useNavigate()
  const {
    aggregatorPublicity,
    tableLoading,
    pagination,
    sorting,
    handleDataChange,
    handlePaginationChange,
    updatePublicityHighLight,
    handleSortingChange,
    getAggregatorPublicity,
    deletePublicityHighLight
  } = useAgregadorPublicity(typeBannerHotel.BANNER)
  const { showDeleteModal } = useModals()
  const [deleteId, setDeleteId] = useState<number>(0)

 const switchStatus = useCallback(
    async (aggregatorPublicity :AggregatorPublicity) => {
      if (aggregatorPublicity) {
        await updatePublicityHighLight(aggregatorPublicity.id, {...aggregatorPublicity, status:!aggregatorPublicity.status } as any)
      }
    },
    [updatePublicityHighLight]
  )

  const columns = useMemo(() => createColumns({ switchStatus }), [switchStatus])

  const actions = useMemo(() => createActions({
    navigate,
    showDeleteModal,
    setDeleteId,
  }), [])




  useEffect(() => {
    getAggregatorPublicity()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  


  return (
    <>
      <div className='row g-5 gx-xxl-12'>
        <div className='card card-xxl-stretch mb-5 mb-xl-12'>
          <div className='card-header py-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-3 mb-1'>
                {i18n.t('aggregador_publicity.title')}
              </span>
              <BreadCrumbs />
              <span className='text-muted mt-1 fw-bold fs-7'>
                {i18n.t('aggregador_publicity.subTitle')}
              </span>
            </h3>
            <div className='card-toolbar'>
              <Button
                text={i18n.t('aggregador_publicity.title_create')}
                color='primary'
                iconColor='#FFF'
                icon='fas fa-plus'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => navigate('create')}
                btnClass='mb-5 fw-bolder'
              />
            </div>
          </div>
          <div className='card-body'>
            <ModularDataTable
              data={aggregatorPublicity}
              columns={columns}
              actions={actions}
              pagination={pagination}
              onPaginationChange={handlePaginationChange}
              sorting={sorting}
              onSortingChange={handleSortingChange}
              onDataChange={handleDataChange}
              searchable={true}
              searchPlaceholder='Pesquisar página...'
              loading={tableLoading}
              selectable={false}
              striped={false}
              hover={false}
              size='md'
              className='table-row-bordered table-row-gray-200'
              alterColumns
              persistPageKey='dinamic_page_agregador'
              persistContextKey='default'
            />
          </div>
        </div>
      </div>
      <ModalDelete confirmAction={() => deletePublicityHighLight(deleteId)} text='delete_item' />
    </>
  )
}

export { AggregadorBannerIndex }